module.exports = __webpack_public_path__ + "static/img/9.dbf6f62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/9.png
// module id = DWuQ
// module chunks = 0